/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { Box, Button, IconButton, Typography } from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import PropTypes from 'prop-types'
import React from 'react'
import { X } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { ROUTES } from '../../../../../helpers/constants'
import { noop } from '../../../../../helpers/utils'
import withRedirect from '../../../../../hocs/RedirectHOC'
import CustomDialog from '../../../../common/CustomDialog'

function AgeRequirement({ open, onClose, programDetail }) {
  const { t } = useTranslation()
  const ButtonEnhanced = withRedirect(Button)

  return (
    <CustomDialog
      paper
      className="custom-dialog"
      close={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle disableTypography id="customized-dialog-title" onClose={onClose}>
        <Typography variant="h5" tabIndex={0}>
          <Box pt={1} fontWeight={700}>
            {t('ageRequirement')}
          </Box>
          <IconButton aria-label="close" className="close-button" onClick={onClose}>
            <X />
          </IconButton>
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography
          component="h4"
          variant="subtitle1"
          color="textPrimary"
          gutterBottom
          tabIndex={0}
        >
          <Box component="span" fontWeight={500} fontSize={16}>
            {programDetail.pgm_maximum_age
              ? t('minMaxAgeLimit', {
                  minAge: programDetail.pgm_minimum_age,
                  maxAge: programDetail.pgm_maximum_age,
                })
              : t('minAgeLimit', {
                  minAge: programDetail.pgm_minimum_age,
                })}
          </Box>
        </Typography>
        <Typography component="h4" variant="body2" color="textPrimary" gutterBottom tabIndex={0}>
          <Box component="span" fontWeight={500}>
            {t('ageLimitNote')}
          </Box>
        </Typography>
      </DialogContent>
      <DialogActions>
        <ButtonEnhanced
          className="text-transform-none"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
          to={ROUTES.PROGRAMCOURSES}
        >
          {t('viewPrograms')}
        </ButtonEnhanced>
      </DialogActions>
    </CustomDialog>
  )
}

AgeRequirement.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  programDetail: PropTypes.object,
}

AgeRequirement.defaultProps = {
  open: false,
  onClose: noop,
  programDetail: {},
}

export default AgeRequirement
